export default __webpack_public_path__ + "static/media/userIcon.514de460.svg";